import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import LeadFormWidget from "@/components/LeadFormWidget";
import { trackEvent } from "@/utils/tracking";

const FinalCTA = ({ settings, content, defaultService, gewerkSlug }) => {
  const ctaContent = content?.cta || {};
  const headline = ctaContent.headline || "Lassen Sie uns Ihr Projekt besprechen";
  const subheadline = ctaContent.subheadline || "Kostenlos & unverbindlich";

  const openWhatsApp = () => {
    window.location.href = '/whatsapp';
  };

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-[#faf8f5] to-white scroll-mt-20" id="lead-form" data-testid="final-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2
            className="text-3xl sm:text-4xl font-bold text-[#4A331D] mb-3"
            style={{ fontFamily: "Work Sans, sans-serif" }}
          >
            {headline}
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            {subheadline}
          </p>
        </div>

        <div className="max-w-xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg border border-[#e8dfd4] p-6 sm:p-8">
            <LeadFormWidget settings={settings} variant="final" defaultService={defaultService} gewerkSlug={gewerkSlug} />
          </div>

          <div className="mt-6 text-center">
            <p className="text-gray-500 text-sm mb-3">Oder direkt & unkompliziert</p>
            <Button
              onClick={openWhatsApp}
              className="bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-5 text-base font-semibold rounded-lg shadow-md"
              data-testid="final-cta-whatsapp"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              Jetzt per WhatsApp schreiben
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
